import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { DollarSign, BarChart3, TrendingUp } from 'lucide-react';
import { Portfolio } from '../../types/index';
import { MockTradingAPI } from '../../services/mockAPI';
import { Card } from '../atoms/Card';


export const DashboardOverview: React.FC = () => {
  const { data: portfolio } = useQuery<Portfolio>({
    queryKey: ['portfolio'],
    queryFn: MockTradingAPI.getPortfolio,
  });

  if (!portfolio) return <div>Loading...</div>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-testid="dashboard-overview">
      <Card className="p-6">
        <div className="flex items-center">
          <DollarSign className="h-8 w-8 text-blue-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-300">Cash Balance</p>
            <p className="text-2xl font-semibold text-gray-900 dark:text-white">
              ${portfolio.balance.toLocaleString()}
            </p>
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center">
          <BarChart3 className="h-8 w-8 text-green-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-300">Portfolio Value</p>
            <p className="text-2xl font-semibold text-gray-900 dark:text-white">
              ${portfolio.totalValue.toLocaleString()}
            </p>
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center">
          <TrendingUp className="h-8 w-8 text-blue-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-300">Day Change</p>
            <p className={`text-2xl font-semibold ${portfolio.dayChange >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              ${portfolio.dayChange.toFixed(2)}
            </p>
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center">
          <TrendingUp className="h-8 w-8 text-purple-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-300">Day Change %</p>
            <p className={`text-2xl font-semibold ${portfolio.dayChangePercent >= 0 ? 'text-green-600' : 'text-red-600'}`}>
              {portfolio.dayChangePercent.toFixed(2)}%
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};